import Button from 'react-bootstrap/Button';
import { SpecialServices } from '../../SpecialServices';
import { LoadingSpinner } from '../../LoadingSpinner';

export const Shortcuts = ({ formik, specialServicesLoading, getSpecialServices, isReturnShipmentTab }) => {
    const reloadSpecialServices = () => {
        if (isReturnShipmentTab) {
            getSpecialServices(true);
        } else {
            getSpecialServices(false);
        }
    }

    return (
        <>
            <fieldset>
                <legend>Special Services <Button onClick={reloadSpecialServices} size='sm' className='link-btn-prpl'>(reload)</Button> </legend>
                {specialServicesLoading ?
                    <LoadingSpinner /> :
                    <SpecialServices formik={formik} shortcutVersion={true} isReturnShipmentTab={isReturnShipmentTab} />
                }
            </fieldset>
        </>
    )
}